// import authApi from './dev';  // dev
import authApi from './prod'; // prod

export default authApi;
